import React from 'react';
import { useAuth } from '../context/AuthContext';

interface NavItem {
  id: string;
  icon: string;
  label: string;
}

const NAV_ITEMS: NavItem[] = [
  { id: 'coaches', icon: '🏋️', label: '教练' },
  { id: 'chat', icon: '💬', label: '对话' },
  { id: 'upmasters', icon: '📚', label: '知识库' },
  { id: 'calendar', icon: '📅', label: '训练日历' },
  { id: 'plans', icon: '📋', label: '训练计划' },
];

interface Props {
  activeNav: string;
  onNavigate: (id: string) => void;
  health: { llm_connected: boolean } | null;
}

export default function Sidebar({ activeNav, onNavigate, health }: Props) {
  const { user, logout } = useAuth();

  return (
    <aside className="rail">
      <div className="rail-brand" title="GymRAG">💪</div>

      <nav className="rail-nav">
        {NAV_ITEMS.map(item => (
          <button
            key={item.id}
            className={`rail-item ${activeNav === item.id ? 'active' : ''}`}
            onClick={() => onNavigate(item.id)}
            title={item.label}
          >
            <span>{item.icon}</span>
            <span className="rail-tip">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="rail-spacer" />

      <div className="rail-user">
        <span
          className={`status-dot ${health?.llm_connected ? 'online' : 'error'}`}
          title={health?.llm_connected ? 'API 在线' : 'API 离线'}
        />
        <div className="rail-avatar" title={user?.username}>
          {(user?.username || '?').slice(0, 1).toUpperCase()}
        </div>
        <button className="rail-logout" onClick={logout} title="退出登录">⏻</button>
      </div>
    </aside>
  );
}
